import { Box, IconButton, InputBase, Stack, useTheme } from "@mui/material";
import React from "react";
import { searchIcon } from "../../../assets";

export const SearchAndView = ({ searchVar, setFiltered }) => {
  const theme = useTheme();
  return (
    <Stack
      direction={"row"}
      justifyContent="flex-start"
      gap="20px"
      sx={{
        marginBottom: "25px",
        width: "98%",
        paddingTop: "16px",
        paddingLeft: "16px",
      }}
    >
      <Box
        display="flex"
        backgroundColor={theme.palette.secondary.dark}
        borderRadius="6px"
        flex={8}
        sx={{ border: "1px solid #F3F5F9" }}
      >
        <IconButton type="button" sx={{ p: 1 }}>
          <img src={searchIcon} alt="search" />
        </IconButton>
        <InputBase
          sx={{ ml: 2, flex: 1, fontSize: "14px" }}
          placeholder="Search By Name or Collection"
          value={searchVar}
          onChange={(e) => setFiltered(e)}
        />
      </Box>
    </Stack>
  );
};
